import React, { useState } from "react";
import { useThemeMode } from '../../context/contextTheme';
import { useDesign } from '../../context/contextDesign';

const SubscriptionCard = () => {
  const { theme } = useThemeMode();
  const { toggleUpgradeCard } = useDesign();
  const [isHovered, setIsHovered] = useState(false);
  
  return(
    <div className="subscription-card">
      <div className="card rounded-4"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ 
          backgroundColor: theme.background,
          border: `1px solid ${isHovered ? theme.borderHover: theme.border}`,
        }}
      >
        <div className="card-body text-center">
          <h5 className="card-title" style={{ color: theme.textColor }}>
            Pro Access
          </h5>
          <p className="card-text" style={{ color: theme.textColor }}>
            Upgrade your plan to access unlimited reports
          </p>
          <div className="btn rounded-pill w-75 mt-1"
           onClick={ toggleUpgradeCard }>
            Upgrade
          </div>
        </div>
      </div>
    </div>
  )
};

export default SubscriptionCard;
